import React from "react";
import type { Course, Skills } from "../../types/learning";
import { Card } from "../ui/Card";
import { ProgressBar } from "../ui/ProgressBar";
import { Tag } from "../ui/Tag";
import { BrutalButton } from "../ui/BrutalButton";
import { getLanguage } from "../../utils/language";
import { skillLabels, weakestSkill } from "../../utils/course";
import { lessonPath } from "../../utils/routes";
interface SkillBalanceProps {
  course: Course;
}
export function SkillBalance({
  course
}: SkillBalanceProps) {
  const weak = weakestSkill(course.skills);
  return <Card as="section" labelledBy="skills-title" className="p-5" data-id="element-228" data-mp="ymakt3rco6cs">
      <h2 id="skills-title" className="text-sm font-bold text-ink-2" data-id="element-229" data-mp="1dgow0i4oabgw">
        Skill balance · {getLanguage(course.target).name}
      </h2>
      <dl className="mt-4 space-y-3" data-id="element-230" data-mp="3f8k4kovmtzuw">
        {(Object.keys(course.skills) as (keyof Skills)[]).map(k => <div key={k} data-id="element-231" data-mp="3a9qrgxk9cav9">
            <div className="mb-1 flex items-center justify-between text-sm" data-id="element-232" data-mp="3aaimo79y06l0">
              <dt className="flex items-center gap-2 font-semibold text-ink" data-id="element-233" data-mp="c21x2pu05o5i">
                {skillLabels[k]}
                {k === weak && <Tag tone="accent" data-id="element-234" data-mp="g4f4dioedu4e">Focus</Tag>}
              </dt>
              <dd className="font-semibold text-ink-2" data-id="element-235" data-mp="l2qfrxucccoq">{course.skills[k]}</dd>
            </div>
            <ProgressBar value={course.skills[k]} size="sm" tone={k === weak ? "accent" : "brand"} label={skillLabels[k]} data-id="element-236" data-mp="pt6v5nhq28dq" />
          </div>)}
      </dl>
      <div className="mt-5" data-id="element-237" data-mp="urrxbsgjb24t">
        <BrutalButton to={lessonPath(course, `focus-${weak}`)} variant="surface" size="sm" full data-id="element-238" data-mp="zrct5u0equdb">
          Practise {skillLabels[weak].toLowerCase()}
        </BrutalButton>
      </div>
    </Card>;
}